var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"backtotal",class:_vm.customClass},[_c('div',{staticClass:"bold-text"},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.title))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"level-one-title ml-auto text-right"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cc54d06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/components/CardTotalComponent.vue
// module id = cys4
// module chunks = 0